module.exports = __webpack_public_path__ + "static/media/bg.f3870eca.png";